import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReverseCalcTableTypeComponent } from './reverse-calc-table-type.component';
import { CastObservablePipe } from '@lockton-apps/shared/ui/pipes';
import { ReverseCalcTableRowTotalPipe } from './pipes/reverse-calc-table-type-total.pipe';

@NgModule({
  declarations: [ReverseCalcTableTypeComponent, ReverseCalcTableRowTotalPipe],
  imports: [
    CommonModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'reverse-calc-table',
          component: ReverseCalcTableTypeComponent,
          wrappers: ['addons'],
        },
      ],
    }),
    CastObservablePipe,
  ],
})
export class ReverseCalcTableTypeModule {}
